import { ButtonClose } from "../ui"; // Botón reutilizable para cerrar
import { PopupProps } from "@/types"; // Tipos para el popup
import { PopupStilosCss } from "../styles"; // Estilos CSS específicos del popup

/**
 * Componente PopupPagoFinal
 * 
 * Modal utilizado para mostrar el resumen/pago final.
 * Incluye contenido centralizado con fondo semitransparente y un botón de cerrar.
 * 
 * @param {PopupProps} props
 * @param {boolean} props.isOpen - Determina si el popup está visible.
 * @param {() => void} props.onClose - Función para cerrar el popup.
 * @param {React.ReactNode} props.children - Contenido del popup.
 * @param {string} [props.className] - Clases CSS adicionales opcionales.
 */
const PopupPagoFinal: React.FC<PopupProps> = ({ isOpen, onClose, children, className }) => {

  // No renderiza nada si isOpen es false
  if (!isOpen) return null;

  return (
    // Contenedor principal que cubre toda la pantalla
    // fixed + inset-0: ocupa todo el viewport
    // flex items-center justify-center: centra el contenido
    // bg-black bg-opacity-70: fondo semitransparente
    // z-50: sobre otros elementos
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50">

      {/* Contenedor interno del popup */}
      {/* Combina clases dinámicas, estilos específicos y diseño responsive */}
      <div className={`${className} ${PopupStilosCss.popupPago}  
        bg-zinc-700 shadow-xl rounded-md p-4 relative w-10/12 md:w-6/12 max-h-[95vh] overflow-y-auto`}
      >
        {/* Contenido del popup */}
        {children}

        {/* Botón de cerrar en la esquina superior derecha */}
        <ButtonClose
          onClick={onClose}
          className="absolute top-1 right-2 rounded-full"
        />
      </div>
    </div>
  );
};

export default PopupPagoFinal;
